export const FETCH_MAIN_TABLE_REQUEST = "FETCH_MAIN_TABLE_REQUEST";
export const FETCH_MAIN_TABLE_SUCCESS = "FETCH_MAIN_TABLE_SUCCESS";
export const FETCH_MAIN_TABLE_FAILURE = "FETCH_MAIN_TABLE_FAILURE";
export const FETCH_MAIN_CITATION_REQUEST = "FETCH_MAIN_CITATION_REQUEST";
export const FETCH_MAIN_CITATION_SUCCESS = "FETCH_MAIN_CITATION_SUCCESS";
export const FETCH_MAIN_CITATION_FAILURE = "FETCH_MAIN_CITATION_FAILURE";
export const FETCH_MAIN_MAP_DATA_REQUEST = "FETCH_MAIN_MAP_DATA_REQUEST";
export const FETCH_MAIN_MAP_DATA_SUCCESS = "FETCH_MAIN_MAP_DATA_SUCCESS";
export const FETCH_MAIN_MAP_DATA_FAILURE = "FETCH_MAIN_MAP_DATA_FAILURE";
export const FETCH_MAIN_TEXT_REQUEST = "FETCH_MAIN_TEXT_REQUEST";
export const FETCH_MAIN_TEXT_SUCCESS = "FETCH_MAIN_TEXT_SUCCESS";
export const FETCH_MAIN_TEXT_FAILURE = "FETCH_MAIN_TEXT_FAILURE";
export const FETCH_MAIN_CATALOG_REQUEST = "FETCH_MAIN_TABLE_REQUEST";
export const FETCH_MAIN_CATALOG_SUCCESS = "FETCH_MAIN_CATALOG_SUCCESS";
export const FETCH_MAIN_CATALOG_FAILURE = "FETCH_MAIN_CATALOG_FAILURE";

export const SET_MAIN_TABLE_COLUMNS = "SET_MAIN_TABLE_COLUMNS";
export const SET_MAIN_TABLE_PARAMS = "SET_MAIN_TABLE_PARAMS";
